import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import successIcon from '../../assets/checkmark.svg';
import homeIcon from '../../assets/home.svg';
import ordersIcon from '../../assets/orders-icon.svg';
import MainContainer from "../../components/container/MainContainer";
import FAQ from '../../components/FAQ/FAQ';
import { getDetails } from '../../services/http/http.service';
import { setOrderTab } from '../../store/selectedAPIs/selectedAPIs.slice';
import { useAppDispatch } from '../../store/storeRequests';
import APIList from '../../utils/constants/APIList';
import { APIResponseCodes } from '../../utils/constants/keys.constants';
import decrypt from '../../utils/helpers/decrypt';
import NotFound from '../404/NotFound';
import './uat-confirmation.css';
import { NavList } from '../../utils/constants/navigation';

const UATConfirmationPage: React.FunctionComponent = () => {

    const isUIMounted = useRef(false)
    const params = useParams()
    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    const [FAQData, setFAQData] = useState([])

    /** GET - FAQ */
    const getFAQ = async () => {
        const response = await getDetails(APIList.GET_FAQ + '?identifier=orders&status=1', getFAQ)
        if (response?.statusCode === APIResponseCodes.SUCCESS) {
            setFAQData(response.data)
        }
    }

    useEffect(() => {
        // window.scrollTo(0, 0)
        if (isUIMounted.current) return
        getFAQ()

    }, [])

    const navigateToOrders = () => {
        decodeURIComponent(decrypt(params?.orderID)).includes('UAT') ? dispatch(setOrderTab('uat')) : dispatch(setOrderTab('prod'))
        navigate(NavList.ORDERS)
    }

    if (decodeURIComponent(decrypt(params?.orderID)).length === 0) {
        return <NotFound />
    } else {

        return (
            <MainContainer>
                <div className="mf-uat-conf scrollTo">
                    <div className='mf-card-shadow mf-uat-conf-card text-center bg-white'>
                        <img width={72} height={72} src={successIcon} alt="success" />
                        <div className="my-4">
                            <p className="mb-0 font-26 weight-600 text-primary-color mf-uat-message"> Your request for {decodeURIComponent(decrypt(params?.orderID)).includes('UAT') ? 'UAT' : 'Production'} has been successfully submitted ! </p>
                            <p className="mb-0 weight-400 text-capitalize uat-order-id mt-3">Order ID: <span className='weight-600'>{decodeURIComponent(decrypt(params?.orderID))}</span></p>
                        </div>
                        <div className="uat-to-btns d-flex align-items-center justify-content-center">
                            <button onClick={navigateToOrders} type='button' className='view-orders-btn primary-bg-color border-0 d-flex align-items-center justify-content-start'>
                                <img width={19} height={19} src={ordersIcon} alt="view orders" />
                                <p className="mb-0 text-capitalize text-white font-14 weight-400 ms-2">View Orders</p>
                            </button>
                            <button onClick={() => navigate(NavList.HOMEPAGE)} type='button' className='go-home-btn primary-bg-color border-0 d-flex align-items-center ms-4'>
                                <img width={19} height={19} src={homeIcon} alt="go home" />
                                <p className="mb-0 text-capitalize text-white font-14 weight-400 ms-2">home</p>
                            </button>
                        </div>
                    </div>
                </div>

                <div className="pt-4 pb-1 my-5 width-75 mx-auto">
                    <h2 className='font-26 weight-700 text-sec-color text-center mb-4 pb-2'>FAQ's</h2>
                    <FAQ FAQData={FAQData} />
                </div>

            </MainContainer>
        )

    }

}

export default UATConfirmationPage